import { InfoOutlined } from '@mui/icons-material';
import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import defaultImage from "../../../assets/images/default.jpg";
import { colors } from '../../../util/SkeletonColor';
import Iconb from '../../extra/Iconb';
import ImagePreviewModal from '../../extra/ImagePreviewModal';
import ShowVideo from '../../extra/ShowVideo';
import Table from '../../extra/Table';
import { OPEN_DIALOGUE } from '../../store/dialogue/dialogue.type';
import { reelInfo } from '../../store/reels/reels.action';
import { CLEAR_REELS } from '../../store/reels/reels.type';
import { getSetting } from '../../store/setting/setting.action';
import FakeReelInformation from './FakeReelInformation';

const ReelsInfo = () => {
  const { state } = useLocation();

  const dispatch = useDispatch();
  const { reelInfoDetails } = useSelector((state) => state.reels);
  const { dialogue, dialogueType } = useSelector((state) => state.dialogue);
  const { setting } = useSelector((state) => state.setting);
  const [data, setData] = useState([])
  const [loading, setLoading] = useState(true);
  const [show, setShow] = useState(false);
  const [url, setUrl] = useState();
  const [showImageModal, setShowImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  useEffect(() => {
    dispatch(getSetting());
  }, [dispatch]);

  useEffect(() => {
    dispatch(reelInfo(state));
  }, [dispatch, state]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1500);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    setData(reelInfoDetails?.productId);
  }, [reelInfoDetails])


  const handleClose = () => {
    setShow(false);
    setUrl("");
  };

  useEffect(() => {
    return () => {
      dispatch({ type: CLEAR_REELS, payload: null });
    }
  }, [])

  const mapData = [
    {
      Header: "No",
      width: "20px",
      Cell: ({ index }) => (
        <span className="text-white fw-normal">
          {index + 1}
        </span>
      ),
    },

    {
      Header: "Image",
      body: "image",
      Cell: ({ row }) => (
        <>
          {loading ? (
            <>
              <Skeleton
                height={40}
                width={40}
                style={{ borderRadius: "50px", cursor: "pointer" }}
                className="StripeElement "
                baseColor={colors?.baseColor}
                highlightColor={colors?.highlightColor}
              />
            </>
          ) : (
            <>
              <img
                src={row?.mainImage}
                style={{ borderRadius: "10px", cursor: "pointer" }}
                height={45}
                width={45}
                alt="category"
                crossOrigin='anonymous'
                onClick={(e) => {
                  e.stopPropagation();
                  if (!row?.mainImage) return;
                  setSelectedImage(row.mainImage);
                  setShowImageModal(true);
                }}
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultImage;
                }}
              />

            </>
          )}
        </>
      ),
    },
    {
      Header: "Product",
      body: "product",
      Cell: ({ row }) => (
        <div className="">
          <p className="mb-0 text-capitalize text-white fw-normal">{row?.productName}</p>
        </div>
      ),
    },


    {
      Header: "product Code",
      body: "productCode",
      Cell: ({ row }) => (
        <span className="boxCenter text-white">
          {row?.productCode}
        </span>
      ),
    },
    {
      Header: "Price",
      body: "price",
      Cell: ({ row }) => (
        <span className="boxCenter text-white">
          {row?.price}({setting?.currency?.symbol})
        </span>
      ),
    },
    {
      Header: "Shipping Charges",
      body: "shippingCharges",
      Cell: ({ row }) => (
        <span className="boxCenter text-white">
          {row?.shippingCharges}({setting?.currency?.symbol})
        </span>
      ),
    },
    {
      Header: "Info",
      body: "",
      Cell: ({ row }) => (
        <Iconb
          newClass={`themeFont boxCenter infobtn userBtn fs-5`}
          btnIcon={<InfoOutlined sx={{ color: '#737272' }} />}
          style={{
            borderRadius: "50px",
            margin: "auto",
            height: "45px",
            width: "45px",
            color: "#160d98",

            padding: "0px"
          }}
          isImage={true}
          isDeleted={true}
          onClick={() => {
            dispatch({
              type: OPEN_DIALOGUE,
              payload: { data: row, type: "fakeReelInfo" },
            });
          }}
        />
      ),
    },

  ];


  return (
    <>
      <ShowVideo
        title={"Video"}
        show={show}
        url={url}
        handleClose={handleClose}
      />
      <div className="mainSellerTable">
        <div className="sellerTable">
          <div className="col-12 headname">Reels</div>
          <div className="sellerMain">
            <div className="tableMain mt-2">
              {dialogue && dialogueType === "fakeReelInfo" && (
                <FakeReelInformation id={state} />
              )}
              <Table
                data={data}
                mapData={mapData}
                // serverPerPage={rowsPerPage}
                // serverPage={page}
                type={"server"}
                loading={loading}
              />
            </div>
          </div>
          <div className="sellerFooter primeFooter"></div>
        </div>
      </div>
      <ImagePreviewModal
        isOpen={showImageModal}
        onClose={() => {
          setShowImageModal(false);
          setSelectedImage("");
        }}
        image={selectedImage}
      />
    </>

  )
}

export default ReelsInfo




